import { useState } from "react";

export const useLocalStorage = (
  /** @type {string} */ keyName,
  /** @type {any} */ defaultValue
) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      let isLocalStorage = window.localStorage.getItem(keyName);
      let isSessionStorage = window.sessionStorage.getItem(keyName);
      const value = isLocalStorage || isSessionStorage;

      if (isLocalStorage) {
        return JSON.parse(value);
      } else {
        window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
        return defaultValue;
      }
    } catch (err) {
      return defaultValue;
    }
  });

  const setValue = (/** @type {any} */ newValue) => {
    try {
      window.localStorage.setItem(keyName, JSON.stringify(newValue));
    } catch (err) {
      console.log(err);
    }
    setStoredValue(newValue);
  };

  return [storedValue, setValue];
};
